import { CONSTANT } from "@/helpers/constant"
import { hasJerseyConfiguratorRights } from "@/helpers/common"

// Everything that is only meaningful with jersey-configurator rights. The settings page
// currently hosts nothing but the JC filter and display group management, so it belongs
// behind the same gate — hiding it in the navigation alone left it reachable by URL.
const JERSEY_CONFIGURATOR_PATHS = [CONSTANT.ROUTE.PATH.DASHBOARD_SALES_FORCE_JERSEY_CONFIGURATOR, CONSTANT.ROUTE.PATH.SALES_FORCE_SETTINGS_INDEX]

const salesforce = ({ to, authedUser, salesChannel }: MiddlewareContext) => {
  const isSalesRep = authedUser?.customFields?.eecom_tp_is_sales_rep || authedUser?.customFields?.eecom_tp_is_super_sales_rep || false

  if (!isSalesRep && to.path.startsWith(CONSTANT.ROUTE.PATH.DASHBOARD_SALES_FORCE)) {
    return false
  }

  if (!hasJerseyConfiguratorRights(salesChannel, authedUser) && JERSEY_CONFIGURATOR_PATHS.some((path) => to.path.startsWith(path))) {
    return false
  }

  return true
}

export default salesforce
